export const selectDepartmentModalTranslationJP = {
  SelectDepartmentModal: {
    head_title: '部門を選択',
    selection: '選択',
    target_date: '対象日',
    no_data_found: 'データが見つかりませんでした。別の日付を選択してください',
    target_store: '対象店舗',
  },
};
